import { Link, useParams } from 'react-router-dom';
import { QrCode, Globe } from 'lucide-react';
import NavigationMenu from './NavigationMenu';
import LanguageToggle from './LanguageToggle';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../i18n/translations';

const SharedHeader = () => {
  const { language } = useLanguage();
  const { lang } = useParams<{ lang: string }>();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-slate-900/80 via-purple-900/80 to-slate-900/80 backdrop-blur-lg border-b border-white/10">
      <div className="flex items-center justify-between max-w-7xl mx-auto px-4 py-4">
        <Link to={`/${lang}`} className="flex items-center gap-3 hover:opacity-80 transition-opacity">
          <div className="p-2 bg-white/10 backdrop-blur-sm rounded-lg">
            <QrCode className="w-6 h-6 text-white" />
          </div>
          <div className="text-left">
            <h1 className="text-xl font-bold text-white">
              {t('title', language)}
            </h1>
            <div className="flex items-center gap-2 text-xs text-gray-300">
              <Globe className="w-3 h-3" />
              <span>www.qrcodeforge.com</span>
            </div>
          </div>
        </Link>

        <div className="flex items-center gap-4">
          <NavigationMenu />
          <LanguageToggle />
        </div>
      </div>
    </header>
  );
};

export default SharedHeader;